import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "vp-card overflow-hidden m-2 md:m-4 md:mt-2.5 md:mr-5" }
const _hoisted_2 = { class: "mx-auto p-4" }
const _hoisted_3 = { class: "flex border-b h-16" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mt-4" }

import { ref } from 'vue';
import CableSpecs from './tabs/CableSpecs.vue';
import PriceUpdatePreview from './tabs/PriceUpdatePreview.vue';
import CopperPriceAnalysis from './tabs/CopperPriceAnalysis.vue';
import { getIsoDate } from '@/utils/copperPriceUtils';
// import UpdateHistory from './tabs/UpdateHistory.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CopperPriceCalculator',
  setup(__props) {

const currentTab = ref('price-update-preview');
const tabs = [
  { id: 'price-update-preview', name: 'Price Update Preview' },
  { id: 'copper-price-analysis', name: 'Copper Price Analysis' },
  { id: 'cable-specs', name: 'Cable Specifications' },
  // { id: 'update-history', name: 'Update History' },
];

const selectedData = ref({
  dates: undefined,
  oldCopperPrice: 0,
  copperPrice: 0,
  selectedPriceList: null
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
          return _createElementVNode("button", {
            key: tab.id,
            onClick: ($event: any) => (currentTab.value = tab.id),
            class: _normalizeClass([
          'px-6 py-3 font-medium text-sm transition-colors duration-200',
          currentTab.value === tab.id
            ? 'border-b-2 border-primary text-gray-900 active-tab-underline'
            : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200',
        ])
          }, _toDisplayString(tab.name), 11, _hoisted_4)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (currentTab.value === 'price-update-preview')
          ? (_openBlock(), _createBlock(PriceUpdatePreview, {
              key: 0,
              modelValue: selectedData.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedData).value = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (currentTab.value === 'copper-price-analysis')
          ? (_openBlock(), _createBlock(CopperPriceAnalysis, {
              key: 1,
              "old-copper-price": selectedData.value.oldCopperPrice,
              "copper-price": selectedData.value.copperPrice,
              dates: selectedData.value.dates?.map(date => _unref(getIsoDate)(date))
            }, null, 8, ["old-copper-price", "copper-price", "dates"]))
          : _createCommentVNode("", true),
        (currentTab.value === 'cable-specs')
          ? (_openBlock(), _createBlock(CableSpecs, { key: 2 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})